let utf8Decoder: TextDecoder | null = null;

function getUtf8Decoder(): TextDecoder {
    utf8Decoder = utf8Decoder || new TextDecoder();
    return utf8Decoder;
}

/**
 * Utility function for decoding utf8 or strings to a string.
 *
 * hxcore contains incorrect typing around some fields -- they are
 * annotated as Utf8Arrays but are sometimes string primitives.
 *
 * This wrapper will check if the passed in value is a string before
 * trying to utf8 decode it.
 */
export function decodeUtf8OrString(input: string | ArrayBuffer) {
    if (typeof input === 'string') {
        return input;
    } else {
        return getUtf8Decoder().decode(input);
    }
}
